import React, { useRef, useState } from 'react'
import { ImLocation2 } from 'react-icons/im';
import { MdOutlineEmail } from 'react-icons/md';
import { BiPhoneCall } from 'react-icons/bi';
import emailjs from '@emailjs/browser';
const Contact = () => {
    const [pendding, setpendding] = useState(false);
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        setpendding(true);
        emailjs.sendForm('service_svjb885', 'template_cijt5it', form.current, 'HBXuz37i_LNxr3Iep')
            .then((result) => {
                setpendding(false);
                console.log(result.text);
                form.current.reset();
                alert("We have received your message and we will contact you soon");
            }, (error) => {
                setpendding(false);
                console.log(error.text);
                form.current.reset();
                alert("You're leaving out some inputs");
            });
    };
    return (
        <>
            <section className="contact-us">
                <div className="contact">
                    <h1 style={{ fontFamily: "heading", color: "#30ADA7" }}>Contact Us</h1>
                    <div className="col-lg-8">
                        <p>"For inquiries or support, reach out to our team at ranarizwan7351@gmail.com or call us at +92 324 5097 351. We value your feedback and are committed to providing excellent service. Don't hesitate to contact us for any assistance you may need."</p>
                    </div>
                </div>
            </section>
            <section className="contact-us-2">
                <div className="container py-5">
                    <h6>CONTACT...</h6>
                    <h1>WRITE US A <span style={{ fontFamily: "heading", color: "#30ADA7" }}>MESSAGE</span></h1>
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-4">
                            <div className="d-flex align-items-center">
                                <div className="left mx-2">
                                    <ImLocation2 />
                                </div>
                                <div className="right mx-2">
                                    <h5>Location:</h5>
                                    <p>Lahore, Punjab Pakistan</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="left mx-2">
                                    <MdOutlineEmail />
                                </div>
                                <div className="right mx-2">
                                    <h5>Email:</h5>
                                    <p>ranarizwan7351@gmail.com</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="left mx-2">
                                    <BiPhoneCall />
                                </div>
                                <div className="right mx-2">
                                    <h5>Calls:</h5>
                                    <p>+92 324 509 7351</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <form ref={form} onSubmit={sendEmail}>
                                <div className="row my-3">
                                    <div className="col-lg-6">
                                        <input required name="name" type="text" className='form-control mt-3' placeholder='Enter Your Name' />
                                        <input required name="phone" type="phone" maxLength={11} className='form-control mt-3' placeholder='Phone' />
                                        <input required name="select_service" type="text" className='form-control mt-3' placeholder='Select Services' />
                                    </div>
                                    <div className="col-lg-6">
                                        <input required name="email" type="email" className='form-control mt-3' placeholder='Email' />
                                        <input required name="address" type="text" className='form-control mt-3' placeholder='address' />
                                        <input required name="subject" type="text" className='form-control mt-3' placeholder='Subject' />

                                    </div>
                                </div>
                                <textarea name='sms' required className='form-control' placeholder="Message" cols="30" rows="10"></textarea>
                                <div className="text-center">
                                    <button className='btn-button mt-3 py-2' disable={pendding ? true : false}>{pendding ? "Loading..." : "Send Message"}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section >
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54423.914658935886!2d74.30097511157088!3d31.510571123574543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190427303d1d9b%3A0x98af47ff5799036e!2zQXJmYSBJVCBUb3dlciDYp9ix2YHYuSDYotim24wg2bnbjCDZudin2YjYsQ!5e0!3m2!1sen!2s!4v1705744590848!5m2!1sen!2s" width="100%" height="350" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </ >
    )
}
export default Contact